module.exports = __webpack_public_path__ + "c035a0170152f9ff6bc5f92a138312a9.svg";